module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-en-c666cf0e9bdb1c85fbb5257530eccb12.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-en.svg
// module id = lXyR
// module chunks = 22 24